var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_wks-define.js
// module id = 69
// module chunks = 0 3 7 10 13 16 17 23 24 25 28 29 30 36 37 39 40 46 54 55 61 66 68 70 72 74 78 79 80 81 82 85 94 97 106 109 111 113 114 140 141 142 147 148 157 159 163 164 165 166 168 169 170 171 172 173